import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/PageHeader";
import { SkeletonCard } from "@/components/Skeletons";
import { formatDate } from "@/lib/format";
import client from "@/lib/api";

const SCORE_LABELS = {
    hidratacion: "Hidratación",
    grasa: "Grasa",
    sensibilidad: "Sensibilidad",
    envejecimiento: "Firmeza / edad",
};
const CONCERN_LABELS = {
    brillos: "Brillos", poros: "Poros marcados", granitos: "Granitos", acne: "Acné",
    sequedad: "Sequedad", tirantez: "Tirantez", rojeces: "Rojeces", sensibilidad: "Sensibilidad",
    manchas: "Manchas", lineas: "Líneas", opacidad: "Piel apagada", deshidratacion: "Deshidratación",
};

export default function AnalysisDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [a, setA] = useState(null);

    useEffect(() => {
        client.get(`/analyses/${id}`).then(({ data }) => setA(data)).catch(() => navigate("/app/analisis"));
    }, [id, navigate]);

    if (!a) {
        return (<><PageHeader title="Tu análisis" /><SkeletonCard /></>);
    }

    return (
        <div className="mx-auto max-w-3xl">
            <PageHeader
                title="Tu piel, en detalle"
                subtitle={`Análisis del ${formatDate(a.created_at)}`}
                action={
                    <Button asChild data-testid="detail-go-routine">
                        <Link to="/app/resultado">Ver mi resultado</Link>
                    </Button>
                }
            />

            <div className="rounded-lg border border-line bg-card p-6">
                <p className="measure text-[17px] leading-[1.6] text-ink" data-testid="analysis-summary">{a.summary}</p>
                {a.concerns?.length > 0 && (
                    <div className="mt-5 flex flex-wrap gap-2">
                        {a.concerns.map((c) => (
                            <span key={c} className="rounded-full border border-line bg-background px-3 py-1 text-[13px] text-subtle">
                                {CONCERN_LABELS[c] || c}
                            </span>
                        ))}
                    </div>
                )}
            </div>

            <div className="mt-6 rounded-lg border border-line bg-card p-6">
                <h3 className="text-[16px] font-bold tracking-tight text-ink">Cómo está tu piel</h3>
                <div className="mt-4 space-y-4">
                    {Object.entries(SCORE_LABELS).map(([k, label]) => {
                        const v = a.scores?.[k] || 0;
                        return (
                            <div key={k}>
                                <div className="flex justify-between text-[14px]">
                                    <span className="text-subtle">{label}</span>
                                    <span className="tnum font-medium text-ink">{v}</span>
                                </div>
                                <div className="mt-1.5 h-2 rounded-full bg-line">
                                    <div className="h-full rounded-full bg-terracotta transition-all duration-200" style={{ width: `${v}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="mt-6 flex flex-wrap gap-3">
                <Button asChild variant="outline"><Link to="/app/neceser">Revisar mi neceser</Link></Button>
                <Button asChild variant="ghost"><Link to="/app/analisis">Ver todos mis análisis</Link></Button>
            </div>
        </div>
    );
}
